'use strict';

// testimonials
(()=>{
	'use strict';
	$('.home-testimonials').mousemove(function(e){

		const wx = $('.home-testimonials').width();
		const wy = $('.home-testimonials').height();

		let x = e.pageX - this.offsetLeft;
		let y = e.pageY - this.offsetTop;

		let newx = x - wx/2;
		let newy = y - wy/2;

		$('.home-testimonials-bg .asset').each( function(){
			let speed = $(this).attr('data-speed');
			if($(this).attr('data-revert')) speed *= -1;
			TweenMax.to(
				$(this), 1, {
					x: (1 - newx * speed),
					y: (1 - newy * speed)
				}
			);
		});
	});

	$('.home-testimonials-fx .testimonial').on('mouseover', (event)=> {
		event.preventDefault();
		$('.home-testimonials-fx .testimonial.active').removeClass('active');
	});

})();
